import { Component, inject, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Store } from '@ngrx/store';
import { FaqWindowComponent, FaqRootItem } from '../faq-window/faq-window.component';
import { LocalChatService } from 'src/app/features/help-faq/services/local-chat.service';
import { FaqWidgetService } from 'src/app/features/help-faq/services/faq-widget.service';
import { FaqAdapter } from 'src/app/features/help-faq/services/faq.adapter';
import { ChatResponse } from 'src/app/features/help-faq/models/chat.models';
import { toObservable } from '@angular/core/rxjs-interop';
import { AppState } from 'src/app/store';
import { selectSigningId } from 'src/app/features/session/store/selectors/session.selectors';

@Component({
    selector: 'app-faq-widget',
    standalone: true,
    imports: [FaqWindowComponent],
    providers: [FaqAdapter],
    templateUrl: './faq-widget.component.html',
    styles: [],
})
export class FaqWidgetComponent {
    private readonly chatService = inject(LocalChatService);
    private readonly document = inject(DOCUMENT);
    private readonly appStore = inject(Store<AppState>);
    private readonly signingId = this.appStore.selectSignal(selectSigningId);
    protected readonly faqAdapter = inject(FaqAdapter);
    protected faqWidgetService = inject(FaqWidgetService);

    rootItems = signal<FaqRootItem[]>([]);

    constructor() {
        toObservable(this.faqWidgetService.isOpen).subscribe(isOpen => {
            if (isOpen) {
                this.document.querySelector('app-shell')?.setAttribute('inert', '');
                this.document.body.classList.add('faq-open');
                this.loadRootItems();
                const id = this.signingId();
                if (id && !this.faqAdapter.hasData()) {
                    void this.faqAdapter.load(id);
                }
            } else {
                this.document.querySelector('app-shell')?.removeAttribute('inert');
                this.document.body.classList.remove('faq-open');
            }
        });
    }

    private loadRootItems(): void {
        this.chatService.getStartNode().subscribe({
            next: (response: ChatResponse) => {
                this.rootItems.set(
                    response.options.map(opt => ({ title: opt.targetNodeId, targetNodeId: opt.targetNodeId }))
                );
            },
        });
    }

    onClose(): void {
        this.faqWidgetService.close();
        this.rootItems.set([]);
    }
}
